export enum Partner {
    Allied = 'allied',
    Asurion = 'asurion',
    AsurionTechCare = 'asuriontechcare',
    ATT = 'att',
    Bluestream = 'bluestream',
    Cox = 'cox',
    Cricket = 'cricket',
    DirecTV = 'directv',
    Dish = 'dish',
    GameStop = 'gamestop',
    HomePro = 'homepro',
    Koodo = 'koodo',
    Liberty = 'liberty',
    Mediacom = 'mediacom',
    NRG = 'nrg',
    Optimum = 'optimum',
    Reach = 'reach',
    RenterTechProtect = 'rentertechprotect',
    Sparklight = 'sparklight',
    Telus = 'telus',
    TelusHomePro = 'telushomepro',
    Viasat = 'viasat',
    Vivint = 'vivint',
    Verizon = 'verizon',
    USCellular = 'uscellular',
}

export enum ProductType {
    General = 'general',
    Home = 'home',
    Mobility = 'mobility',
    Appliance = 'appliance',
    Default = 'default',
}

export type Purchase = {
    RetailName: string;
    RetailSKU: string;
    PurchaseDate: string;
};

export type AgreementCustomer = {
    FirstName?: string;
    LastName?: string;
    Email?: string;
};

export type ClientAccount = {
    ClientChannelId: string;
    Type: string;
};

export type Agreement = {
    Id: string;
    ClientAccount: ClientAccount;
    SubscriptionNumber: string;
    Purchase?: Purchase;
    Status: string;
    Customers?: AgreementCustomer[];
    TerminationDate?: string;
};

export type BasePlanDetails = {
    id: string;
    plan: string;
    productType: ProductType;
    displayName: string;
};

export type PlanDetails = {
    plan: BasePlanDetails;
    agreement: Agreement;
};

export type VerifiedPlanDetails = PlanDetails & {
    verifiedThisSession: boolean;
};

export type Subscription = {
    clientChannelId: string;
    subscriptionNumber: string;
};

export type VerifiedSubscription = Subscription & {
    verifiedThisSession: boolean;
};

export type UserPlanDetails = PlanDetails & {
    isVerified?: boolean;
    isSelected?: boolean;
};

export type UserPlansServices = {
    client: string;
    services: string[];
    plans: UserPlanDetails[];
};
